import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-500/20">
                <i className="ri-book-open-line text-accent-500 text-lg"></i>
              </span>
              <span className="text-lg font-bold font-heading text-foreground-950">
                漫画导航
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              专业的成人漫画内容导航与推荐平台，为成熟读者提供分类清晰、合规安全的阅读指引。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 whitespace-nowrap">快速导航</h4>
            <div className="space-y-2.5">
              <Link to="/" className="block text-sm text-foreground-500 hover:text-accent-500 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/josei-romance" className="block text-sm text-foreground-500 hover:text-accent-500 transition-colors whitespace-nowrap">分类浏览</Link>
              <Link to="/about" className="block text-sm text-foreground-500 hover:text-accent-500 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 whitespace-nowrap">内容分类</h4>
            <div className="space-y-2.5">
              <Link to="/category/josei-romance" className="block text-sm text-foreground-500 hover:text-accent-500 transition-colors whitespace-nowrap">女性向恋爱</Link>
              <Link to="/category/seinen-drama" className="block text-sm text-foreground-500 hover:text-accent-500 transition-colors whitespace-nowrap">青年向剧情</Link>
              <Link to="/category/fantasy-isekai" className="block text-sm text-foreground-500 hover:text-accent-500 transition-colors whitespace-nowrap">奇幻异世界</Link>
              <Link to="/category/thriller-mystery" className="block text-sm text-foreground-500 hover:text-accent-500 transition-colors whitespace-nowrap">悬疑惊悚</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 whitespace-nowrap">合规声明</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              本站内容仅供18岁以上读者浏览。我们倡导支持正版，所有推荐均指向获得合法授权的正规平台。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 text-xs text-accent-500">
                <i className="ri-shield-check-line"></i>
                18+
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 漫画导航 - 成人漫画精选推荐平台。本站内容仅供18岁以上用户参考。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors" rel="nofollow">使用条款</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors" rel="nofollow">内容声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}